import { render } from "./scenario-select-trainer.vue?vue&type=template&id=c589a80c&ts=true"
import script from "./scenario-select-trainer.vue?vue&type=script&lang=ts"
export * from "./scenario-select-trainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__